








import { StringProp } from '@/util/prop-decorators';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Bubble extends Vue {
  @StringProp()
  public readonly caption?: string;
}
